import { removeArrayElement, removeObjectKey } from '../util/state'

import {
  APPEND_TEMPLATE_FIELD_TO_LIST,
  EDIT_TEMPLATE_FIELD_TYPE,
  EDIT_TEMPLATE_NAME,
  FETCH_CHANGE_ACTIVE_TEMPLATE_ID,
  FETCH_CHANGE_ACTIVE_TEMPLATE_ID_SUCCESS,
  FETCH_CREATE_TEMPLATE,
  FETCH_CREATE_TEMPLATE_SUCCESS,
  FETCH_DELETE_TEMPLATE,
  FETCH_DELETE_TEMPLATE_SUCCESS,
  FETCH_SAVE_TEMPLATE,
  FETCH_SAVE_TEMPLATE_SUCCESS,
  FETCH_TEMPLATES,
  FETCH_TEMPLATES_SUCCESS,
  REMOVE_TEMPLATE_FIELD_FROM_LIST,
  SET_TEMPLATE_LIST_SHOW_STATUS,
  UPDATE_TEMPLATE_FIELDS
} from '../constants/ActionTypes'

export default (state = {
  byId: {},
  allIds: [],
  activeId: null,
  loading: false,
  ready: false,
  changeTemplateLoading: false,
  saveLoading: false,
  deleteLoading: false,
  unsavedChanges: false
}, {type, payload}) => {
  switch (type) {
    case FETCH_TEMPLATES:
      return {
        ...state,
        loading: true
      }

    case FETCH_TEMPLATES_SUCCESS:
      return {
        ...state,
        byId: payload.byId,
        allIds: payload.allIDs,
        activeId: payload.activeId,
        loading: false,
        ready: true
      }

    case FETCH_CHANGE_ACTIVE_TEMPLATE_ID:
      return {
        ...state,
        changeTemplateLoading: true
      }

    case FETCH_CHANGE_ACTIVE_TEMPLATE_ID_SUCCESS:
      return {
        ...state,
        activeId: payload.id,
        changeTemplateLoading: false
      }

    case FETCH_CREATE_TEMPLATE:
      return {
        ...state,
        changeTemplateLoading: true
      }

    case FETCH_CREATE_TEMPLATE_SUCCESS:
      return {
        ...state,
        byId: {
          ...state.byId,
          [payload.id]: payload.entry
        },
        allIds: [...state.allIds, payload.id],
        activeId: payload.activeId,
        changeTemplateLoading: false
      }

    case EDIT_TEMPLATE_NAME:
      return {
        ...state,
        byId: {
          ...state.byId,
          [payload.id]: {
            ...state.byId[payload.id],
            name: payload.name
          }
        },
        unsavedChanges: true
      }

    case UPDATE_TEMPLATE_FIELDS:
      return {
        ...state,
        byId: {
          ...state.byId,
          [payload.id]: {
            ...state.byId[payload.id],
            lists: {
              ...state.byId[payload.id].lists,
              [payload.type]: {
                ...state.byId[payload.id].lists[payload.type],
                fields: payload.fields
              }
            }
          }
        },
        unsavedChanges: true
      }

    case APPEND_TEMPLATE_FIELD_TO_LIST:
      return {
        ...state,
        byId: {
          ...state.byId,
          [payload.id]: {
            ...state.byId[payload.id],
            lists: {
              ...state.byId[payload.id].lists,
              [payload.type]: {
                ...state.byId[payload.id].lists[payload.type],
                fields: [
                  ...state.byId[payload.id].lists[payload.type].fields,
                  state.byId[payload.id].unusedFields[payload.index]
                ]
              }
            },
            unusedFields: [
              ...state.byId[payload.id].unusedFields.slice(0, payload.index),
              ...state.byId[payload.id].unusedFields.slice(payload.index + 1)
            ]
          }
        },
        unsavedChanges: true
      }

    case REMOVE_TEMPLATE_FIELD_FROM_LIST:
      return {
        ...state,
        byId: {
          ...state.byId,
          [payload.id]: {
            ...state.byId[payload.id],
            unusedFields: [
              ...(state.byId[payload.id].unusedFields || []),
              state.byId[payload.id].lists[payload.type].fields[payload.index]
            ],
            lists: {
              ...state.byId[payload.id].lists,
              [payload.type]: {
                ...state.byId[payload.id].lists[payload.type],
                fields: [
                  ...state.byId[payload.id].lists[payload.type].fields.slice(0, payload.index),
                  ...state.byId[payload.id].lists[payload.type].fields.slice(payload.index + 1)
                ]
              }
            }
          }
        },
        unsavedChanges: true
      }

    case EDIT_TEMPLATE_FIELD_TYPE:
      return {
        ...state,
        byId: {
          ...state.byId,
          [payload.id]: {
            ...state.byId[payload.id],
            lists: {
              ...state.byId[payload.id].lists,
              [payload.type]: {
                ...state.byId[payload.id].lists[payload.type],
                fields: [
                  ...state.byId[payload.id].lists[payload.type].fields.slice(0, payload.index),
                  {
                    ...state.byId[payload.id].lists[payload.type].fields[payload.index],
                    type: payload.fieldType
                  },
                  ...state.byId[payload.id].lists[payload.type].fields.slice(payload.index + 1)
                ]
              }
            }
          }
        },
        unsavedChanges: true
      }

    case SET_TEMPLATE_LIST_SHOW_STATUS:
      return {
        ...state,
        byId: {
          ...state.byId,
          [payload.id]: {
            ...state.byId[payload.id],
            lists: {
              ...state.byId[payload.id].lists,
              [payload.type]: {
                ...state.byId[payload.id].lists[payload.type],
                showStatus: payload.showStatus
              }
            }
          }
        },
        unsavedChanges: true
      }

    case FETCH_SAVE_TEMPLATE:
      return {
        ...state,
        saveLoading: true
      }

    case FETCH_SAVE_TEMPLATE_SUCCESS:
      return {
        ...state,
        saveLoading: false,
        unsavedChanges: false
      }

    case FETCH_DELETE_TEMPLATE:
      return {
        ...state,
        deleteLoading: true
      }

    case FETCH_DELETE_TEMPLATE_SUCCESS:
      return {
        ...state,
        byId: removeObjectKey(state.byId, payload.id),
        allIds: removeArrayElement(state.allIds, payload.id),
        activeId: payload.activeId,
        deleteLoading: false
      }

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./reducers/Templates.js